<template>
<div class='b-transfer-list__wrapper'>
    <div class='b-transfer-list__column'>
        <div class='b-transfer-list__column__title'>
            <FwCheckbox
                id='optionsAll'
                v-model='showAllOptionsChecked'
                type='common-with-text'
                :text='allOptionsTitle'
                :showMinus='showOptionsMinus'
                noIndent
                itemWidth='auto'
                name='checkbox'
                @change='updateOptionsAll'>
            </FwCheckbox>
        </div>
        <div v-for='(item, index) in options'
             :key='item.id'
             class='b-transfer-list__column__item'>
            <div class='h-flex'>
                <FwCheckbox
                    :id='item.id'
                    v-model='optionsSelected'
                    type='common-with-text'
                    :value='index'
                    :text='item.title'
                    itemWidth='auto'
                    name='checkbox'>
                </FwCheckbox>
            </div>
        </div>
    </div>
    <div class='b-transfer-list__arrow-wrapper'>
        <div class='b-transfer-list__arrow'
             :class='{ "b-transfer-list__arrow--active": isArrowRightActive }'
             @click='onArrowRightClick'>
            <FwIcon
                class='h-flex-center'
                icon='arrow-right'
                size='16px'
                color='#fff'>
            </FwIcon>
        </div>
        <div class='b-transfer-list__arrow'
             :class='{ "b-transfer-list__arrow--active": isArrowLeftActive }'
             @click='onArrowLeftClick'>
            <FwIcon
                class='h-flex-center'
                icon='arrow-left'
                size='16px'
                color='#fff'>
            </FwIcon>
        </div>
    </div>
    <div class='b-transfer-list__column'>
        <div class='b-transfer-list__column__title'>
            <FwCheckbox
                id='optionsAll'
                v-model='showAllModelChecked'
                type='common-with-text'
                :text='allModelTitle'
                :showMinus='showModelMinus'
                noIndent
                itemWidth='auto'
                name='checkbox'
                @change='updateModelAll'>
            </FwCheckbox>
        </div>
        <div v-for='(item, index) in model'
             :key='item.id'
             class='b-transfer-list__column__item'>
            <div class='h-flex'>
                <FwCheckbox
                    :id='item.id'
                    v-model='modelSelected'
                    type='common-with-text'
                    :value='index'
                    :text='item.title'
                    itemWidth='auto'
                    name='checkbox'>
                </FwCheckbox>
            </div>
        </div>
    </div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import FwCheckbox from '../forms/FwCheckbox.vue';
import FwIcon from '../FwIcon.vue';
import { Component, Prop, Watch, Emit } from 'vue-property-decorator';

@Component({
    components: {
        FwCheckbox,
        FwIcon,
    },
})
export default class FwTransferList extends Vue {
    @Prop({ type: Array, required: true }) readonly model!: Array<any>;
    @Prop({ type: Array, required: true }) readonly options!: Array<any>;
    @Prop({ type: Array, default: () => ['element', 'elements'] }) readonly allOptionsPostfix!: Array<string>;
    @Prop({ type: Array, default: () => ['element', 'elements'] }) readonly allModelsPostfix!: Array<string>;

    optionsSelected: Array<any> = [];
    modelSelected: Array<any> = [];
    showAllOptionsChecked: boolean = this.optionsSelected.length ? this.optionsSelected.length === this.options.length : false;
    showAllModelChecked: boolean = this.modelSelected.length ? this.modelSelected.length === this.model.length : false;

    get allOptionsTitle(): string {
        const prefix = this.optionsSelected.length ? `${this.optionsSelected.length}/` : ``;
        return `${prefix}${this.options.length} ${this.options.length === 1 ? this.allOptionsPostfix[0] : this.allOptionsPostfix[1]}`;
    }

    get showOptionsMinus(): boolean {
        return !!(this.optionsSelected.length && this.optionsSelected.length < this.options.length);
    }

    get allModelTitle(): string {
        const prefix = this.modelSelected.length ? `${this.modelSelected.length}/` : ``;
        return `${prefix}${this.model.length} ${this.model.length === 1 ? this.allModelsPostfix[0] : this.allModelsPostfix[1]}`;
    }

    get showModelMinus(): boolean {
        return !!(this.modelSelected.length && this.modelSelected.length < this.model.length);
    }

    get isArrowRightActive(): boolean {
        return !!this.optionsSelected.length;
    }

    get isArrowLeftActive(): boolean {
        return !!this.modelSelected.length;
    }

    updateOptionsAll(flag: boolean): void {
        if (!flag) {
            this.showAllOptionsChecked = false;
            this.optionsSelected = [];
        } else {
            this.showAllOptionsChecked = true;
            this.optionsSelected = [...Array(this.options.length).keys()];
        }
    }

    updateModelAll(flag: boolean): void {
        if (!flag) {
            this.showAllModelChecked = false;
            this.modelSelected = [];
        } else {
            this.showAllModelChecked = true;
            this.modelSelected = [...Array(this.model.length).keys()];
        }
    }

    onArrowRightClick(): void {
        if (!this.isArrowRightActive) return;
        this.updateModelHandler(this.optionsSelected);
        this.optionsSelected = [];
    }

    onArrowLeftClick(): void {
        if (!this.isArrowLeftActive) return;
        this.updateOptionsHandler(this.modelSelected);
        this.modelSelected = [];
    }

    @Emit(`updateOptions`)
    updateOptionsHandler(modelSelected: Array<any>) {
        return modelSelected.map(x => this.model[x]);
    }

    @Emit(`updateModel`)
    updateModelHandler(optionsSelected: Array<any>) {
        return optionsSelected.map(x => this.options[x]);
    }

    @Watch(`optionsSelected`)
    optionsSelectedHandler(optionsSelected: Array<any>) {
        this.showAllOptionsChecked = optionsSelected.length ? optionsSelected.length === this.options.length : false;
    }

    @Watch(`modelSelected`)
    modelSelectedHandler(modelSelected: Array<any>) {
        this.showAllModelChecked = modelSelected.length ? modelSelected.length === this.model.length : false;
    }
}
</script>

<style lang='sass'>
.b-transfer-list
    &__wrapper
        width: 100%
        display: flex

    &__column
        flex: 3 0
        height: 330px
        overflow: auto
        padding: 0 0 15px
        background-color: #fff
        border: 1px solid rgba(33,63,107,0.1)
        border-radius: 10px
        box-shadow: 0 30px 11px -17px rgba(33,63,107,0.05)

        &__item
            padding: 0 15px

        &__title
            display: flex
            align-items: center
            border-bottom: 1px solid rgba(33,63,107,0.1)
            margin-bottom: 15px
            padding: 10px 15px
            font-size: 14px
            font-weight: 500

    &__arrow-wrapper
        flex: 1 0
        padding: 15px
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        height: 330px

    &__arrow
        width: 100%
        max-width: 70px
        background: #B1B1B1
        border-radius: 7px
        display: flex
        align-items: center
        justify-content: center
        height: 30px
        margin: 9px 0

        &--active
            background-color: #213F6B
            cursor: pointer
            transition: .2s opacity
            &:hover
                opacity: 0.9
</style>
